export const QR_CODE_DATA_TEST_ID = 'QR_CODE_DATA_TEST_ID';
